import { Fragment, useEffect, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { getNotUserOrderDetail, orderFinalConfirm } from '../apis/orders';
import { Checkbox } from '../components/Checkbox';
import { DirectoryBar } from '../components/DirectoryBar';
import { H6 } from '../components/H6';
import { InfoSection } from '../components/MyPage/InfoSection';
import { ProductSection } from '../components/MyPage/ProductSection';
import { ShippingInfoSection } from '../components/MyPage/ShippingInfoSection';
import OrderDetailProductItem from '../components/OrderDetailProductItem';
import OrderNumberSection from '../components/OrderNumberSection';
import PaymentInfoMobile from '../components/PaymentInfoMobile';
import PaymentInfoPC from '../components/PaymentInfoPC';
import { PopUp } from '../components/PopUp';
import { Section } from '../components/Section';
import { Table } from '../components/Table';
import { Bridge } from "../plugins/bridge";
import { nToast } from '../plugins/reactToast';
import { OrderPaidProduct, TOrderDetail } from '../types/types';

const NonMemberOrderDetail = () => {
  const { orderNumber } = useParams<{ orderNumber: string; }>();
  const history = useHistory();
  const [order, setOrder] = useState<TOrderDetail>();
  const [popUp, setPopUp] = useState(false);
  const [selected, setSelected] = useState<OrderPaidProduct[]>([]);
  const [confirmTargetId, setConfirmTargetId] = useState<number>();
  const mounted = useRef(false);

  useEffect(() => {
    if (!mounted.current) mounted.current = true;
    else {
      Bridge.sendAmplitude('non_member_order_check_completed', { order_id: orderNumber });
    }
  }, [orderNumber]);

  const [productRequestOrderNumber, setProductRequestOrderNumber] =
    useState<string>();

  useEffect(() => {
    const customerName = localStorage.getItem('customerName');
    const customerPhone = localStorage.getItem('customerPhone');
    getNotUserOrderDetail(orderNumber, {
      customerName: customerName!,
      customerPhone: customerPhone!,
    }).then(r => setOrder(r.data.payload)).catch(e => console.log(e));
  }, [history]);

  const itemIndex = (item: OrderPaidProduct) => {
    return selected.findIndex(i => i === item);
  };

  const onChecked = (product: OrderPaidProduct) => {
    itemIndex(product) > -1
      ? setSelected([...selected.filter(i => i !== product)])
      : setSelected([...selected, product]);
  };

  const orderConfirm = () => {
    orderFinalConfirm(productRequestOrderNumber || orderNumber, {
      customerName: order?.customerName,
      customerPhone: order?.customerPhone,
      orderProductIds: [confirmTargetId!],
    }).then(r => {
      const target = selected.find(i => i.productId === confirmTargetId);
      // Bridge.sendBraze(BRAZE_EVENT.ORDER_CONFIRMED, {
      //     non_member_order: true,
      //     item_id: String(confirmTargetId),
      //     item_name: target?.productName,
      //     item_category: undefined,
      //     item_color: target?.color,
      //     item_gender: undefined,
      //     item_size: target?.sizeName,
      //     item_price: target?.unitPrice,
      //     item_discount_rate: (1 - target?.discountedUnitPrice! / target?.unitPrice!) * 100,
      //     item_discount_price: target?.discountedUnitPrice,
      //     order_item_quantity: target?.count,
      //     total_order_items_quantity: order?.products.map(product => product.count).reduce((a, b) => a + b, 0),
      //     sub_total: order?.productPrice,
      //     payment_method: swapPayMethod(order?.payMethod!),
      //     paid_shipping: order?.deliveryPrice,
      //     paid_point: order?.usedMileage,
      //     coupon_id: order?.appliedCoupons?.map(c => c.couponId).join(','),
      //     coupon_name: order?.appliedCoupons?.map(c => c.name).join(','),
      //     reward_point: order?.earnedMileage,
      //     order_id: order?.orderId,
      //     order_total: order?.totalPrice,
      // });

      // Bridge.sendAmplitude('order_confirm_completed', {
      //   non_member_order : true,
      //   item_id : String(confirmTargetId),
      //   item_name : target?.productName,
      //   item_category : '?',
      //   item_color : target?.color,
      //   item_gender : '?',
      //   item_size : target?.sizeName,
      //   item_price : target?.unitPrice,
      //   item_discount_price : target?.discountedUnitPrice,
      //   item_discount_rate : (1 - target?.discountedUnitPrice! / target?.unitPrice!) * 100,
      //   order_item_quantity : target?.count,
      //   total_order_items_quantity : order?.products.map(product => product.count).reduce((a, b) => a + b, 0),
      //   sub_total : order?.productPrice,
      //   payment_method : swapPayMethod(order?.payMethod!),
      //   paid_shipping: order?.deliveryPrice,
      //   paid_point: order?.usedMileage,
      //   coupon_id: order?.appliedCoupons?.map(c => c.couponId).join(','),
      //   coupon_name: order?.appliedCoupons?.map(c => c.name).join(','),
      //   reward_point: order?.earnedMileage,
      //   order_id: order?.orderId,
      //   order_total: order?.totalPrice
      // })

      nToast(`구매 확정이 완료되었습니다`);
    }).catch(e => console.log(e));
  };

  if (!order) return null;
  return (
    <div className="md:mx-auto md:my-30 max-w-screen-xl">
      <PopUp
        title="구매 확정"
        description="구매 확정 시 적립금이 즉시 지급 됩니다. 단, 구매 확정 시에는 해당 제품은 교환 및 환불이 불가 하오니 참고부탁드립니다."
        buttonText="구매 확정하기"
        onClick={() => {
          orderConfirm();
          setPopUp(false);
        }}
        onClose={() => setPopUp(false)}
        open={popUp}
      />

      <DirectoryBar text="주문상세내역" backArrow className="md:hidden" />

      <div className="space-y-8 md:space-y-14">
        <Section className="space-y-4 text-13">
          <div className="flex justify-between items-center border-b pb-4">
            <H6>주문상세내역</H6>
            {order.status !== 'CANCELED' &&
              order.products[0].productStatus === 'PENDING' && (
                <button
                  onClick={() =>
                    history.push(`/non-member/${order.orderNumber}/cancel`, {
                      nOrder: order,
                      products: order.products,
                    })
                  }
                  className="text-13 bg-gray-100 px-3 py-2">
                  전체 주문 취소
                </button>
              )}
          </div>
          <OrderNumberSection
            orderNumber={order.orderNumber}
            orderedAt={order.orderedAt!}
          />
        </Section>

        {/* Desktop ProductSection */}
        <ProductSection
          hideActions={
            order.status === 'CANCELED' || order.status === 'CONFIRMED'
          }
          orderNumber={orderNumber}
          shippingStatus={order.shippingStatus}
          selectedProducts={selected}
          order={order}
          className="hidden md:block"
          content={
            <Table className="mt-5">
              <Table.Head>
                <Table.Row>
                  <Table.Th>
                    <Checkbox
                      className="bg-white border border-gray-300"
                      checked={order.products === selected}
                      onChange={() =>
                        order.products === selected
                          ? setSelected([])
                          : setSelected(order.products)
                      }
                    />
                  </Table.Th>
                  <Table.Th>상품</Table.Th>
                  <Table.Th>사이즈</Table.Th>
                  <Table.Th>적립금 적립</Table.Th>
                  <Table.Th>총 결제금액</Table.Th>
                  <Table.Th>배송상태</Table.Th>
                  <Table.Th></Table.Th>
                </Table.Row>
              </Table.Head>
              <Table.Body>
                {order.products.map((product, index) => (
                  <Fragment key={index}>
                    <OrderDetailProductItem
                      order={order}
                      product={product}
                      checked={itemIndex(product) > -1}
                      onChecked={() => onChecked(product)}
                      onConfirm={() => {
                        setPopUp(true);
                        setProductRequestOrderNumber(
                          product.latestRequest === 'EXCHANGE'
                            ? product.latestRequestOrderNumber
                            : undefined,
                        );
                        setConfirmTargetId(product.orderProductId);
                      }}
                    />
                    {product.latestRequestOrderNumber && (
                      <OrderDetailProductItem
                        order={order}
                        product={product}
                        isRequestItem={true}
                      />
                    )}
                  </Fragment>
                ))}
              </Table.Body>
            </Table>
          }
        />

        {/* Mobile Product Section */}

        <ProductSection
          hideActions={
            order.status === 'CANCELED' || order.status === 'CONFIRMED'
          }
          orderNumber={orderNumber}
          shippingStatus={order.shippingStatus}
          selectedProducts={selected}
          order={order}
          className="md:hidden"
          content={order.products.map((product, index) => (
            <div key={index}>
              <OrderDetailProductItem
                mobile={true}
                order={order}
                product={product}
                checked={itemIndex(product) > -1}
                onChecked={() => onChecked(product)}
                onConfirm={() => {
                  setPopUp(true);
                  setProductRequestOrderNumber(
                    product.latestRequest === 'EXCHANGE'
                      ? product.latestRequestOrderNumber
                      : undefined,
                  );
                  setConfirmTargetId(product.orderProductId);
                }}
              />
              {product.latestRequestOrderNumber && (
                <OrderDetailProductItem
                  mobile={true}
                  order={order}
                  product={product}
                  isRequestItem={true}
                />
              )}
            </div>
          ))}
        />

        <InfoSection name={order.customerName!} phone={order.customerPhone!} />

        <ShippingInfoSection hideActions={true} order={order} />

        {/* Desktop 결제 정보 Section  */}
        <Section className="hidden md:block text-13">
          <H6 className="border-b pb-4">결제 정보</H6>

          <PaymentInfoPC order={order} />

          <div className="grid place-items-end">
            <div className="space-x-3 pt-14">
              <button
                className="bg-brand-1 text-white rounded-md px-10 py-3"
                onClick={() => window.open(order.cashReceiptUrl)}>
                영수증내역 출력
              </button>
              {order.receiptUrl && (
                <button
                  className="bg-brand-1 text-white rounded-md px-10 py-3"
                  onClick={() => window.open(order.receiptUrl)}>
                  주문서 내역 출력
                </button>
              )}
            </div>
          </div>
        </Section>

        {/* Mobile 결제 정보 Section */}
        <Section className="md:hidden text-13">
          <H6 className="border-b pb-4 mb-4">결제 정보</H6>

          <PaymentInfoMobile order={order} />
        </Section>
      </div>
    </div>
  );
};

export default NonMemberOrderDetail;
